import { Component, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { InconsistenciaBeneficioView } from 'src/app/models/inconsistencias-beneficio/inconsistencia-beneficio-view';
import { TratativasProdutoService } from '@services/tratativas-produto.service';
import { GoogleComponent } from '@pages/utils/google.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';
import { SelectComponent } from '../select/select.component';
import { NgClass, CurrencyPipe } from '@angular/common';
import { MultiselectCustomComponent } from '../multiselect-custom/multiselect-custom.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-tratativas-produtos',
    templateUrl: './tratativas-produtos.component.html',
    styleUrls: ['./tratativas-produtos.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TagManagerDirective, SelectComponent, NgClass, MultiselectCustomComponent, FormsModule, CurrencyPipe]
})
export class TratativasProdutosComponent extends GoogleComponent {
  private readonly idImportacao: any;
  private readonly idEmpresaLogada: number;
  public inconsistenciasProdutos: Array<InconsistenciaBeneficioView> = [];
  public regioesCadastradas: any = null;
  public produtos: Array<any>;
  public enviandoParaApi = false;
  public erroEnvioParaApi = false;
  public sucessoEnvioApi = false;
  public qtdeInconsistencias = 0;
  public enviandoIgnorarTodos: boolean;
  public erroIgnorarTodos: boolean;
  public sucessoIgnorarTodos: boolean;
  loaderProdutos: boolean;

  private readonly sectionApp = 'tratativas';
  private readonly screenName = 'tratativas:manutencao-de-produto';
  private readonly screenType = 'pagina';

  constructor(private readonly service: TratativasProdutoService) {
    super();
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
    this.idImportacao = localStorage.getItem('idImportacao');
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagInteraction(elementType, elementContent, this.sectionApp, this.screenName, this.screenType);
  }

  consultaFabricantes(idRegiao: string, index: any) {
    this.service.getFabricantes(idRegiao).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.inconsistenciasProdutos.find((item) => item.numeroLinha == index).fabricantes = response.response;
      },
      error: (erro: any) => console.error(erro)
    });
  }

  consultaProduto(idFabricante: string, index: any) {
    this.loaderProdutos = true;
    console.clear();
    this.service.getProdutos(idFabricante).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.inconsistenciasProdutos.find((item) => item.numeroLinha == index).produtos = response.response;
        setTimeout(() => this.loaderProdutos = false, 0);
      },
      error: (erro: any) => console.error(erro)
    });
  }

  exibeNomeBeneficio(nomeProduto: any, indexRecebido: number) {
    const inconsistencia = this.inconsistenciasProdutos.find(item => item.numeroLinha === indexRecebido);
    if (!nomeProduto) {
      if (inconsistencia) inconsistencia.prodDePara = null;
      return;
    }
    if (inconsistencia) {
      inconsistencia.produtos.forEach((item: any) => {
        if (nomeProduto === item.descricaoProduto) inconsistencia.prodDePara = item.idProduto;
      });
    }
  }

  deParaInconsistencia(objInconsistencia: InconsistenciaBeneficioView) {
    this.enviandoParaApi = true;
    this.erroEnvioParaApi = false;
    this.sucessoEnvioApi = false;
    const data = this.getFormDataRequest(objInconsistencia);
    this.service.realizaDepara(data, this.idImportacao).pipe(take(1)).subscribe({
      next: () => {
        this.enviandoParaApi = false;
        this.erroEnvioParaApi = false;
        this.sucessoEnvioApi = true;
        this.updateInconsistenciasProduto(objInconsistencia, true);
      },
      error: (erro: any) => {
        this.enviandoParaApi = false;
        this.erroEnvioParaApi = true;
        objInconsistencia.processado = 'N';
        this.updateInconsistenciasProduto(objInconsistencia, false);
        console.error(erro);
      }
    });
  }

  ignorarInconsistenica(objInconsistencia: InconsistenciaBeneficioView) {
    this.enviandoParaApi = true;
    this.erroEnvioParaApi = false;
    this.sucessoEnvioApi = false;
    const body = this.getFormDataRequest(objInconsistencia, true);
    this.service.realizaDepara(body, this.idImportacao).pipe(take(1)).subscribe({
      next: () => {
        this.enviandoParaApi = false;
        this.erroEnvioParaApi = false;
        this.sucessoEnvioApi = true;
        this.updateInconsistenciasProduto(objInconsistencia, true);
      },
      error: (erro: any) => {
        this.enviandoParaApi = false;
        this.erroEnvioParaApi = true;
        this.updateInconsistenciasProduto(objInconsistencia, false);
        console.error(erro);
      }
    });
  }

  ignorarTodasInconsistencias() {
    this.enviandoIgnorarTodos = true;
    this.erroIgnorarTodos = false;
    this.sucessoIgnorarTodos = false;
    this.service.ignorarTodasInconsistencias(this.idImportacao).pipe(take(1)).subscribe({
      next: () => {
        this.inconsistenciasProdutos.forEach((item) => {
          this.fechaResolucaoInconsistencia(item.numeroLinha + 1);
          item.processado = 'S';
        });
        this.enviandoIgnorarTodos = false;
        this.erroIgnorarTodos = false;
        this.sucessoIgnorarTodos = true;
        this.updateInconsistenciasCounter();
      },
      error: (erro: any) => {
        this.enviandoIgnorarTodos = false;
        this.erroIgnorarTodos = true;
        this.sucessoIgnorarTodos = false;
        console.error(erro);
      }
    });
  }

  abrirFecharResolucao(indexInconsistencia: any) {
    const flechaResolucao = document.querySelector('#flechaResolucao2' + indexInconsistencia);
    const colunaResolucao = document.querySelector('#colunaResolucao2' + indexInconsistencia);
    if (flechaResolucao.classList.contains('fa-chevron-right')) {
      flechaResolucao.classList.remove('fa-chevron-right');
      flechaResolucao.classList.add('fa-chevron-down');
      colunaResolucao.classList.remove('d-none');
      this.erroEnvioParaApi = false;
    } else {
      this.fechaResolucaoInconsistencia(indexInconsistencia);
    }
  }

  fechaResolucaoInconsistencia(index: number): void {
    const flechaResolucao = document.querySelector('#flechaResolucao2' + index);
    const colunaResolucao = document.querySelector('#colunaResolucao2' + index);
    if (!flechaResolucao.classList.contains('fa-chevron-right')) {
      flechaResolucao.classList.remove('fa-chevron-down');
      flechaResolucao.classList.add('fa-chevron-right');
      colunaResolucao.classList.add('d-none');
    }
  }

  getFormDataRequest(inconsistencia: InconsistenciaBeneficioView, ignorarInconsistencia = false): FormData {
    const formData = new FormData();
    formData.append('cnpj', inconsistencia.cnpj);
    formData.append('importation-id', `${inconsistencia.idImportacao}`);
    formData.append('new-product-description', inconsistencia.descricao.slice(0, 80));
    formData.append('old-product-value', `${inconsistencia.productValue}`);
    formData.append('old-product-code', inconsistencia.cdCodVenPro);
    formData.append('company-id', `${this.idEmpresaLogada}`);
    if (ignorarInconsistencia) {
      formData.append('future-conflicts', 'I');
      formData.append('new-product-id', '-1');
    } else {
      formData.append('future-conflicts', inconsistencia.gravaBanco ? 'Y' : 'N');
      formData.append('new-product-id', inconsistencia.prodDePara);
    }
    formData.append('user-code', inconsistencia.userCode);
    return formData;
  }

  updateInconsistenciasProduto(inconsistenciaObj: InconsistenciaBeneficioView, resolved: boolean): void {
    const objIndex = inconsistenciaObj.numeroLinha;
    inconsistenciaObj.processado = resolved ? 'S' : 'N';
    if (resolved) this.fechaResolucaoInconsistencia(objIndex + 1);
    const newList = [
      ...this.inconsistenciasProdutos.slice(0, objIndex),
      ...this.inconsistenciasProdutos.slice(objIndex + 1),
    ];
    newList.push(inconsistenciaObj);
    this.updateInconsistenciasCounter();
    this.updateInconsistenciasList(newList);
  }

  updateInconsistenciasList(inconsistenciasList: Array<InconsistenciaBeneficioView>): void {
    this.inconsistenciasProdutos = [...inconsistenciasList].sort((a, b) => a.numeroLinha - b.numeroLinha);
  }

  updateInconsistenciasCounter(): void {
    this.qtdeInconsistencias = this.inconsistenciasProdutos.filter((item) => item.processado == 'N').length;
    this.service.changeQtdeInconProdu.emit(this.qtdeInconsistencias);
  }
}
